import { AxiosResponse } from "axios";
import businessPortalClient from "../businessPortalClient";
import { Statuses } from "../components/DelegeeStatus/DelegeeStatus";
import { getQueryString } from "../utils/url.utils";
import { DelegatedPedestrianRightsWithPagination } from "../models/delegations/DelegatedPedestrianRight";
import { InvitePedestrianRightRequestModel } from "../models/InvitePedestrianRightRequestModel";
import { PedestrianProductModel } from "../models/PedestrianProductModel"
import { RevokePedestrianRightsModel } from "../models/vehicle-assignments/RevokePedestrianRightsModel";
import { DeletePedestrianDelegeesModel } from "../models/vehicle-assignments/DeletePedestrianDelegeesModel";

const baseUrl = "/api/pedestrianrights";

export type GetDelegatedPedestrianRightsQuery = {
  seasonTicketOwnerCrmId: string;
  placeId: number;
  language: string;
  pmcIds?: number[];
  name?: string;
  email?: string;
  statuses?: Statuses[];
  page: number;
  pageSize: number;
  sortBy?: 'name' | 'email' | 'invitationDate' | 'status';
  ascending?: boolean;
  invitationFrom?: string;
  invitationTo?: string;
};

export function getDelegatedPedestrianRights(q: GetDelegatedPedestrianRightsQuery) : Promise<AxiosResponse<DelegatedPedestrianRightsWithPagination>> {
  const { seasonTicketOwnerCrmId, language, ...others } = q;
  const qs = getQueryString(others);

  const url = `${baseUrl}/GetDelegatedPedestrianRights/${seasonTicketOwnerCrmId}/${language}?${qs}`
  return businessPortalClient.get(url);
}

export function getPedestrianProducts(
  seasonTicketOwnerCrmId: string,
  language: string
) : Promise<AxiosResponse<PedestrianProductModel[]>> {
  const url = `${baseUrl}/getpedestrianproducts/${seasonTicketOwnerCrmId}/${language}`
  return businessPortalClient.get(url);
}

export function inviteDelegee(request: InvitePedestrianRightRequestModel) {
  const url = `${baseUrl}/invitedelegee`
  return businessPortalClient.post(url, request);
}

export function revokePedestrianRights(model: RevokePedestrianRightsModel): Promise<AxiosResponse> {
  const url = `${baseUrl}/RevokePedestrianRights`;
  return businessPortalClient.post(url, model);
};

export type ResendInviteModel = {
  email: string;
  customerId: string;
}

export function resendInvite(model: ResendInviteModel) : Promise<AxiosResponse> {
  const url = `${baseUrl}/ResendInvite`;
  return businessPortalClient.post(url, model);
}

export function deletePedestrianDelegees(model: DeletePedestrianDelegeesModel): Promise<AxiosResponse> {
    const url = `${baseUrl}/DeletePedestrianDelegees`;
    return businessPortalClient.post(url, model);
};
